/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { goToTop, eventTracker } from '_helpers';
import { colors } from '_styles';
import { _ } from '_locales';
import images from '_images';
import moment from 'moment';
import { secondaryColor } from '_apis';
import { calendar as calendarSetup } from '_actions';
import { CalendarTable, EventSlider } from './component';
import { setLastVisitedMonthValue } from '../../redux/actions/calendar';
import { extractWholeMonthEvents } from './helpers';
// import style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;
const Container = styled.div`
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;
const Header = styled.div`
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
`;
const Main = styled.div`
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px 0px;
    margin-top: 40px;
`;
const ChangeZoneBox = styled.div`
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 7px 0;
  border-radius: 4px;
  background-color: #ffffff;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
`;
const ChangeZoneBtn = styled.button`
  display: flex; 
  -moz-appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
   
  font-size: 14px !important;
  text-align: left;
  color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  background-color: #fff;
  position: relative;
  padding: 0;
  &:focus {
    outline: none;
  }
`;
const Pen = styled.div`
  width: 19px;
  height: 19px;
  background-image: url(${images.calendar.changeZone});
  background-color: #fff;
  background-repeat: no-repeat;
  flex: 1;
  margin-right: 5px;
`;
const InnerTextOfChangeZoneBtn = styled.span`
  cursor: pointer;
  text-transform: capitalize;
  ${ChangeZoneBtn}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px;
  }
  &:focus {
    outline: none;
  }
`;
const YourLocation = styled.p`
  margin: 20px 0px 0px !important;
  font-size: 14px !important;
  text-align: left !important;
  font-weight: 500 !important;
  color: #000 !important;
  text-transform: capitalize;
`;
const LocationText = styled.p`
  font-size: 19px !important;
  text-align: left !important; 
  font-weight: 500 !important;
  margin: 0 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 125px);
  color: #000 !important;
`;
const MonthTitle = styled.h2`
  font-size: 18px !important;
  font-weight: 500 !important;
  margin: 0px !important;
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ArrowContainer = styled.div`
    flex: 1;
    max-width: 76px;
    height: 22px;
    position: relative;
`;
const ArrowBox = styled.button`
    all: initial;
  font-family: Roboto, sans-serif !important;
    display: inline-block;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: none;
    border: none;
    outline: none;
    top: 0;
    position: absolute;
    width: 21px !important;
    height: 21px;
    background-size: 70%;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    cursor: pointer;
    
    &:first-child {
      background-image: url(${images.calendar.leftArrow});
      left: 0px;
    }
    &:last-child {
      background-image: url(${images.calendar.rightArrow});
      right: 0px;
    }
    &:focus {
      outline: none;
    }
`;
const InnerArrowBox = styled.span`
    padding: 6px 17px;
    cursor: pointer;
    display: inline;
    position: relative;
    width: -0.2px;
    box-sizing: border-box;
    padding: 0 auto;
    margin: 2px;
    ${ArrowBox}:focus > & {
      box-shadow: 0px 0px 1px 2px #51a7e8;
      border-radius: 5px;
    }
    &:focus {
      outline: none;
    }
`;
const CalOptionsContainer = styled.div`
  margin: 30px auto 45px auto;
  display: flex;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;

  ${(parentWidth < 501) && css`
    .reminder {
      display: none;
    }
    flex-direction: column;
    padding: 0 20px;
  `};
`;
const CalBtn = styled.button`
  padding: 13px 25px;
  border-radius: 4px;
  border: solid 1px ${colors.RC_ACTION};
  background-color: transparent;
  cursor: pointer;
  text-transform: capitalize;
  margin-right: 12px;
  &:last-child {
    margin-right: 0;
  }
  ${(parentWidth < 501) && css`
    margin-bottom: 15px;
    margin-right: 0px;
  `};
`;
const Span = styled.span`
  font-size: 15px !important;
  font-weight: 400 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.RC_ACTION};
`;
const EventBox = styled.div`
    width: 100%;
    /* height: 445px; */
    overflow: hidden;
    padding: 15px 20px;
    box-sizing: border-box;
    display: none;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
    ${(parentWidth < 501) && css`
      display: block;
    `};
`;
const ResponsiveContainer = styled.div`
    display: none;
    ${(parentWidth < 501) && css`
      width: 100%;
      height: auto;
      overflow: hidden;
      padding: 15px 0px;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
      display: block;
      margin-top: 25px;
    `};
`;
const CalendarHeaderResponsive = styled.div`
  ${(parentWidth < 501) && css`
    width: 100%;
    display: flex;
    position: relative;
    margin-bottom: 15px;
    h2 {
      flex: 1;
      text-align: center !important;
    }
    button {
      flex: 1;
      position: relative;
      background-size: 50%;
      max-width: 40px !important;
    }
  `};
`;
const NormalModeContainer = styled.div`
  display: block;
  ${(parentWidth < 501) && css`
    display: none;
  `};
`;
// End style
const Calendar = ({
  config, calendar, zone, props, setEventInfo, lastVisitedMonthValue, setLastVisitedMonthValue
}) => {
  const { eventInfo } = calendar;
  const { mapCityName, fullAddress } = zone;
  const {
    collection, schedule, isMultiDistrict, shouldSeeDistrictSelector, districtId
  } = config;
  const hideButtons = districtId === 'MOMENTMR';
  const { history } = props;
  const [isDisable, setIsDisable] = useState(false);
  const [dateContext, setDateContext] = useState(moment());
  const month = dateContext.format('MMMM');
  let fullDateContext = { ...dateContext };
  const curMonth = moment(fullDateContext).month(); /* months() is deprecated */
  const curYear = moment(fullDateContext).year(); /* years() is deprecated */
  /**
     * Go to the prev month
     */
  const prevMonth = () => {
    fullDateContext = moment(fullDateContext).subtract(1, 'month');
    setDateContext(fullDateContext);
    setEventInfo({ day: 0, month: 'curr' });
    setLastVisitedMonthValue(lastVisitedMonthValue - 1);
  };
  /**
     * Go to the next month
     */
  const nextMonth = () => {
    fullDateContext = moment(fullDateContext).add(1, 'month');
    setDateContext(fullDateContext);
    setEventInfo({ day: 0, month: 'curr' });
    setLastVisitedMonthValue(lastVisitedMonthValue + 1);
  };
  const constantCurrentMonth = moment().month();
  const constantCurrentYear = moment().year();
  let specificEvents;
  let prevMonthSpecificEvents;
  let nextMonthSpecificEvents;
  if (
    schedule
    && Object.keys(schedule).length
  ) {
    schedule.map((item) => {
      if (item.year === curYear && (curMonth !== 0 || curMonth !== 11)) {
        item.months.map((res) => {
          if (res.month === curMonth + 1) {
            specificEvents = res.events;
            return specificEvents;
          }
          if (res.month === curMonth) {
            prevMonthSpecificEvents = res.events;
            return prevMonthSpecificEvents;
          }
          if (res.month === curMonth + 2) {
            nextMonthSpecificEvents = res.events;
            return nextMonthSpecificEvents;
          }
          return res;
        });
      }
      if (item.year === curYear && curMonth === 0) {
        item.months.map((res) => {
          if (res.month === curMonth + 1) {
            specificEvents = res.events;
            return specificEvents;
          }
          if (res.month === curMonth + 2) {
            nextMonthSpecificEvents = res.events;
            return nextMonthSpecificEvents;
          }
          return res;
        });
        // make sure the data is in schedule array.
        const prevYearsData = schedule.find((i) => i.year === item.year - 1);
        if (prevYearsData && prevYearsData?.months) {
          const prevDecemberEvents = prevYearsData?.months.find((i) => i.month === 12)?.events;
          if (prevDecemberEvents) {
            prevMonthSpecificEvents = prevDecemberEvents;
          }
        }
      }
      if (item.year === curYear && curMonth === 11) {
        item.months.map((res) => {
          if (res.month === curMonth + 1) {
            specificEvents = res.events;
            return specificEvents;
          }
          if (res.month === curMonth) {
            prevMonthSpecificEvents = res.events;
            return prevMonthSpecificEvents;
          }
          return res;
        });
        // make sure the data is in schedule array.
        const nextYearsData = schedule.find((i) => i.year === item.year + 1);
        if (nextYearsData && nextYearsData?.months) {
          const nextJanuaryEvents = nextYearsData?.months.find((i) => i.month === 1)?.events;
          if (nextJanuaryEvents) {
            nextMonthSpecificEvents = nextJanuaryEvents;
          }
        }
      }
      return null;
    });
  }
  const currentMonthEvents = extractWholeMonthEvents(specificEvents);
  const prevMonthsEvents = extractWholeMonthEvents(prevMonthSpecificEvents);
  const nextMonthsEvents = extractWholeMonthEvents(nextMonthSpecificEvents);
  // display different selected months event slider depending on events in mobile view
  let selectedMonth;
  let selectedMonthsEvents;
  if (eventInfo.month === 'prev') {
    selectedMonth = curMonth - 1;
    selectedMonthsEvents = prevMonthsEvents;
  }
  if (eventInfo.month === 'curr') {
    selectedMonth = curMonth;
    selectedMonthsEvents = currentMonthEvents;
  }
  if (eventInfo.month === 'next') {
    selectedMonth = curMonth + 1;
    selectedMonthsEvents = nextMonthsEvents;
  }
  useEffect(() => {
    eventTracker('Plugin Click', { action: 'Calendar', title: 'My_Schedule' });
    // go to the months where user clicked and and went to an event
    fullDateContext = moment(fullDateContext).add(lastVisitedMonthValue, 'month');
    setDateContext(fullDateContext);
    setEventInfo({ day: 0, month: 'curr' });
  }, []);
  useEffect(() => {
    if (
      (
        curYear === constantCurrentYear
        && curMonth < constantCurrentMonth
      )
      || curYear < constantCurrentYear
      || !Object.keys(currentMonthEvents).length
    ) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [curMonth, curYear, isDisable]);
  const decideRouting = () => {
    goToTop();
    if (
      isMultiDistrict
      && shouldSeeDistrictSelector
    ) {
      return history.push('/select-districts');
    }
    return history.push('/zone-setup');
  };
  return (
    <Container>
      <Header>
        <YourLocation>{_('zone.your_location')}</YourLocation>
        <ChangeZoneBox>
          <LocationText>
            {fullAddress || mapCityName.search_nm}
          </LocationText>
          <ChangeZoneBtn onClick={() => decideRouting()} tabIndex="0" aria-label="change the address">
            <Pen />
            <InnerTextOfChangeZoneBtn tabIndex="-1">
              {_('general.change_address')}
            </InnerTextOfChangeZoneBtn>
          </ChangeZoneBtn>
        </ChangeZoneBox>
      </Header>
      <Main>
        {/* Responsive Part of Event Box, max-width: 730px */}
        {
          !isDisable && (
            <EventBox>
              <EventSlider
                curYear={curYear}
                selectedMonth={selectedMonth}
                eventInfo={eventInfo}
                collection={collection}
                selectedMonthsEvents={selectedMonthsEvents}
                currentMonthEvents={currentMonthEvents}
              />
            </EventBox>
          )
        }
        <ResponsiveContainer>
          <CalendarHeaderResponsive>
            <ArrowBox tabIndex="0" onClick={prevMonth} aria-label="back to the previous month">
              <InnerArrowBox tabIndex="-1" />
            </ArrowBox>
            <MonthTitle>{`${month} ${curYear}`}</MonthTitle>
            <ArrowBox tabIndex="0" onClick={nextMonth} aria-label="forward to the next month">
              <InnerArrowBox tabIndex="-1" />
            </ArrowBox>
          </CalendarHeaderResponsive>
          <CalendarTable
            disabled
            dateContext={dateContext}
            currentMonthEvents={currentMonthEvents}
            prevMonthsEvents={prevMonthsEvents}
            nextMonthsEvents={nextMonthsEvents}
          />
        </ResponsiveContainer>
        {/* End of Responsive Part */}
        {/* Normal mode */}
        <NormalModeContainer>
          <TitleContainer>
            <MonthTitle>{`${month} ${curYear}`}</MonthTitle>
            <ArrowContainer>
              <ArrowBox tabIndex="0" onClick={prevMonth} aria-label="back to the previous month">
                <InnerArrowBox tabIndex="-1" />
              </ArrowBox>
              <ArrowBox tabIndex="0" onClick={nextMonth} aria-label="forward to the next month">
                <InnerArrowBox tabIndex="-1" />
              </ArrowBox>
            </ArrowContainer>
          </TitleContainer>
          <CalendarTable
            disabled={false}
            dateContext={dateContext}
            currentMonthEvents={currentMonthEvents}
            prevMonthsEvents={prevMonthsEvents}
            nextMonthsEvents={nextMonthsEvents}
            month={month}
            curYear={curYear}
          />
        </NormalModeContainer>
        {/* end of normal mode */}
      </Main>
      {/* <Footer> */}
      <CalOptionsContainer>

        {!hideButtons && (
          <CalBtn className="reminder" tabIndex="0" onClick={() => [goToTop(), history.push('/cal/reminder')]} secondaryColor={secondaryColor} aria-label="select to go to the reminder page">
            <Span>{_('cal.set_edit_reminder')}</Span>
          </CalBtn>
        )}
        {!hideButtons && (
          <CalBtn tabIndex="0" onClick={() => [goToTop(), history.push('/cal/export-calendar')]} secondaryColor={secondaryColor} aria-label="select to go to the export calendar page">
            <Span>{_('cal.export_calendar')}</Span>
          </CalBtn>
        )}
        <CalBtn tabIndex="0" onClick={() => [goToTop(), history.push('/cal/download-pdf')]} secondaryColor={secondaryColor} aria-label="select to go to the download pdf page">
          <Span>{_('cal.download_pdf_calendar')}</Span>
        </CalBtn>
      </CalOptionsContainer>
      {/* </Footer> */}
    </Container>
  );
};
const mapStateToProps = (state) => ({
  lastVisitedMonthValue: state.calendar.lastVisitedMonthValue
});
const mapDispatchToProps = (dispatch) => ({
  setEventInfo: (eventInfo) => dispatch(calendarSetup.setEventInfo(eventInfo)),
  setLastVisitedMonthValue: (month) => dispatch(setLastVisitedMonthValue(month))
});
export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
